export default {"src":"/_next/static/media/ethos.416ad92f.svg","height":16,"width":25};